import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { TranslateService } from '@ngx-translate/core';
import { UserActionBaseComponent } from '../userAction-base.component';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';

@Component({
    selector: 'userAction-markAsChanged',
    templateUrl: 'userAction-markAsChanged.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionMarkAsChangedComponent) }
    ],
    standalone: false
})
export class UserActionMarkAsChangedComponent extends UserActionBaseComponent {
  markCategoriesAsChanged: boolean = false;
  markProductsAsChanged: boolean = false;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
  }

  public async canStartMacro() : Promise<boolean>{
    if (!(this.markCategoriesAsChanged || this.markProductsAsChanged)) {
      this.systemService.notifyInfo(this.translate.instant('mindestens ein Schalter'));
      return false;
    }

   return true;
  }

  parseParameter(parameter: string) {
    try {
      const parsed = JSON.parse(parameter);
      this.markCategoriesAsChanged = parsed.markCategoriesAsChanged;
      this.markProductsAsChanged = parsed.markProductsAsChanged;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString(): string {
    return JSON.stringify({
      markCategoriesAsChanged: this.markCategoriesAsChanged,
      markProductsAsChanged: this.markProductsAsChanged
    });
  }
}
